<template>
    <div style="max-height: 600px; overflow: auto">
        <div class="layer-content">
            <table class="tb-col tb-req-detail">
                <colgroup>
                    <col style="width:80px;" />
                    <col style="width:60px;" />
                    <col style="width:70px;" />
                    <col style="width:110px;" />
                    <col style="width:110px;" />
                    <col style="width:110px;" />
                    <col style="width:110px;" />
                    <col style="width:110px;" />
                    <col style="width:110px;" />
                    <col style="width:*;" />
                </colgroup>
                <thead>
                <tr>
                    <th>기준년월</th>
                    <th>현원</th>
                    <th>리더기<br/>수량</th>
                    <th>전월미납금</th>
                    <th>결제할<br/>금액</th>
                    <th>결제금액</th>
                    <th>결제수단</th>
                    <th>상태</th>
                    <th>미납금</th>
                    <th class="last">비고</th>
                </tr>
                </thead>
                <tbody>
                    <template v-if="monthPayList.length > 0">
                        <tr v-for="(payInfo, index) in monthPayList" :key="'payInfo_'+index">
                            <td>{{getYmFormat(payInfo.yyyymm)}}</td>
                            <td>{{payInfo.chilCnt}}명</td>
                            <td>{{payInfo.detectorCnt}}대</td>
                            <td>{{$onbiLib.addComma(payInfo.amtBefUnpaid)}}원</td>
                            <td>{{$onbiLib.addComma(payInfo.amtReq)}}원</td>
                            <td>{{$onbiLib.addComma(payInfo.amt)}}원</td>
                            <td>{{payInfo.paymethodNm}}</td>
                            <td>{{payInfo.sttusNm}}</td>
                            <td>{{$onbiLib.addComma(payInfo.amtUnpaid)}}원</td>
                            <td class="last">{{payInfo.bigo}}</td>
                        </tr>
                    </template>
                    <template v-if="monthPayList.length == 0">
                        <tr>
                            <td colspan="10">월 이용료 기준 현황이 존재하지 않습니다.</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'monthPaySttusPopup',
        props:['param'],
        data: function(){
            return{
                monthPayList : new Array(),
            }
        },
        methods : {
            searchMonthPaySttusList : function(){
                const _this = this;
                this.axios.post('/i5gam/srvc/searchMonthPaySttusList.act',{
                    fcltcd : _this.param.fcltcd,
                }).then(function(response) {
                    _this.monthPayList = response.data.monthPayList;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            getYmFormat : function(ym){
                return ym.substr(0, 4) + '-' + ym.substr(4, 2)
            }
        },
        mounted : function() {
            this.searchMonthPaySttusList();
        }
    }
</script>